/**
 * The Link wraps around React Router's Link component, to automatically replace
 * it by the regular <a> element when:
 * - The target reference points to another domain;
 * - User opts to open the reference in a new tab;
 * - User explicitely opts to use <a>.
 */

import { type LinkProps, Link as RrLink } from 'react-router';

import GenericLink, { type PropsT as GenericLinkPropsT } from './GenericLink';

type PropsT = LinkProps & Omit<GenericLinkPropsT, 'routerLinkType'>;

const Link: React.FunctionComponent<PropsT>
  = (props) => (
    <GenericLink
      // TODO: Avoid the spreading later.
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      routerLinkType={RrLink}
    />
  );

export default Link;
